export default __webpack_public_path__ + "417981ce9618dbf5d61dc769c92603a8.png";